export interface MPagination<T> {
  count: number;
  current?: number;
  results: T[];
}

export const emptyPagination: MPagination<any> = {
  count: 0,
  current: 0,
  results: [],
};

export interface PaginationInquiry {
  page: number;
  pageSize: number;
  warehouseId?: string;
}

export interface IoPagination<T> {
  totalElements: number;
  current?: number;
  content: T[];
}


export const emptyIoPagination: IoPagination<any> = {
  totalElements: 0,
  current: 0,
  content: [],
};
